import { post } from "../../libs/ajax.js"
// 排单排期 v2 · 排单管理（素材工单 menu tab wos_schedule_manage）
// 阶段16·Task11：操作类全指向 schedule_manage/*。状态模型：已排单=status1 / 已定版=status3（待排单 status0 走 scheduling/pool）。
export default {
  // 列表（status IN(1,3) + 状态汇总 summary{pending=status1, finalized=status3} + view_perm 视图档）
  getList: (data, options) => {
    return post("/work_order/schedule_manage/list", data, options)
  },
  // 筛选选项
  getOptions: (data, options) => {
    return post("/work_order/schedule_manage/options", data, options)
  },
  // tabs 数量（轻量独立·pool/pending/finalized/approval + view_perm·徽标用）
  tabCounts: (data, options) => {
    return post("/work_order/schedule_manage/tab_counts", data, options)
  },
  // 产能水位（期望完成日×大类组）
  getWater: (data, options) => {
    return post("/work_order/schedule_manage/water", data, options)
  },
  // 排单动作记录
  getLogList: (data, options) => {
    return post("/work_order/schedule_manage/log_list", data, options)
  },
  // 记录筛选选项
  getLogOptions: (data, options) => {
    return post("/work_order/schedule_manage/log_options", data, options)
  },
  // 定版（闸② 1→3·单）
  finalize: (data, options) => {
    return post("/work_order/schedule_manage/finalize", data, options)
  },
  // 批量定版（order_ids 逗号串或数组·1→3）
  batchFinalize: (data, options) => {
    return post("/work_order/schedule_manage/batch_finalize", data, options)
  },
  // 直接操作（type: delivery{delivery} / priority{priority}·创意直接生效·返回可带 capacity_warning）
  adjust: (data, options) => {
    return post("/work_order/schedule_manage/adjust", data, options)
  },
  // 批量改期（创意）
  batchAdjust: (data, options) => {
    return post("/work_order/schedule_manage/batch_adjust", data, options)
  },
  // 创意置换（单·A⇄B 互换制作组·直接生效·跨天放开）data:{order_id, swap_target_order_id}
  swap: (data, options) => {
    return post("/work_order/schedule_manage/swap", data, options)
  },
  // 创意换组（单·移到目标组·直接生效·跨天放开）data:{order_id, group_id, category_group_id}
  regroup: (data, options) => {
    return post("/work_order/schedule_manage/regroup", data, options)
  },
  // 批量换组（创意·集合·跨天放开）data:{order_ids, group_id, category_group_id}
  batchRegroup: (data, options) => {
    return post("/work_order/schedule_manage/batch_regroup", data, options)
  },
  // 批量置换（创意·集合互换·跨天放开）data:{src_ids, dst_ids}
  batchSwap: (data, options) => {
    return post("/work_order/schedule_manage/batch_swap", data, options)
  },
  // 运营置换申请（owner 对自己单 → 运营负责人+创意负责人双签）data:{order_id, swap_target_order_id, reason}
  opsApply: (data, options) => {
    return post("/work_order/schedule_manage/ops_apply", data, options)
  },
  // 改落点（创意·直接生效·组+日期一次二维移动·阶段17）走 adjust(type=relocate)
  // data:{order_id, type:'relocate', group_id, category_group_id, delivery}·返回可带 capacity_warning
  relocate: (data, options) => {
    return post("/work_order/schedule_manage/adjust", { ...data, type: "relocate" }, options)
  },
  // 批量改落点（创意·同组+同日应用全部选中单·阶段17）走 batch_adjust(type=relocate)
  // data:{order_ids, type:'relocate', group_id, category_group_id, delivery}·返回 data.capacity_warning 供二次确认
  batchRelocate: (data, options) => {
    return post("/work_order/schedule_manage/batch_adjust", { ...data, type: "relocate" }, options)
  },
  // 运营改落点申请（owner 对自己单改组/日期 → 创意负责人单签·阶段17）data:{order_id, group_id, category_group_id, delivery, reason}
  applyRelocate: (data, options) => {
    return post("/work_order/schedule_manage/apply_relocate", data, options)
  },
  // 运营改落点选目标制作组（挂 ops_apply 节点·运营有权·复用组树·for_apply=1 返全制作组·阶段17）
  // data:{only_capacity:1, for_apply:1}
  relocateGroups: (data, options) => {
    return post("/work_order/schedule_manage/relocate_groups", data, options)
  },
  // 创意选目标制作组（改落点/换组/置换/待排池落点·审批超产能落点）·挂排单管理 tab 节点·复用组树 only_capacity=1
  // v4 BUG-002-BT：原调 ConfAPI.getSchedulingGroups(/scheduling/group_options·挂产能配置节点)，角色不勾产能配置即 403 → 下拉全空
  groupOptions: (data, options) => {
    return post("/work_order/schedule_manage/group_options", data, options) // 后端 I('param.') GET/POST 都读
  },
  // 待排单·单条落点（设组/改期/优先级·status0→1·阶段16）data:{order_id, type∈{group,delivery,priority}, group_id?, category_group_id?, delivery?, priority?}
  poolAdjust: (data, options) => {
    return post("/work_order/schedule_manage/pool_adjust", data, options)
  },
  // 待排单·批量设组落点（整批→目标组+日期·status0→1·阶段16）data:{order_ids, group_id, category_group_id, delivery}
  poolBatchRegroup: (data, options) => {
    return post("/work_order/schedule_manage/pool_batch_regroup", data, options)
  },
  // 撤回（已排 status1/已定版 status3 → 待排单 status0·释放已占产能·下次预排重新参与）data:{order_id, reason 必填}
  withdraw: (data, options) => {
    return post("/work_order/schedule_manage/withdraw", data, options)
  },
  // 驳回（单条·待排 status0/已排 status1/已定版 status3 → 工单 order_status 被驳回 3·级联清排单层）
  // data:{order_id, rejected_reason 必填·最长 20 字}。权限节点 schedule_reject。
  reject: (data, options) => {
    return post("/work_order/schedule_manage/reject", data, options)
  },
  // 批量驳回（逐单独立事务·部分成功也返回 succ·info 已含人话汇总·data.errors 逐单回传失败原因）
  // data:{order_ids, rejected_reason 必填·最长 20 字}。与单条共用 schedule_reject 节点。
  batchReject: (data, options) => {
    return post("/work_order/schedule_manage/batch_reject", data, options)
  },
  // 批量撤回（workOrder_v5 §3·已排/已定版 → 待排单·逐单独立事务·部分成功也返回 succ·info 含人话汇总·data.{done,fail,errors}）
  // data:{order_ids, reason 必填}。与单条撤回共用 schedule_withdraw 节点。
  batchWithdraw: (data, options) => {
    return post("/work_order/schedule_manage/batch_withdraw", data, options)
  },
  // 工单详情弹框（按工单明细行·每 plat/规格一行·需求+指派拆分）data:{order_id}
  detailList: (data, options) => {
    return post("/work_order/schedule_manage/detail_list", data, options)
  },
  // 导出（已排单/已定版·传 fields/筛选进 data）
  exportScheduleManage: (data, options) => {
    return post("/work_order/schedule_manage/export", data, options)
  },
  // 已撤回工单 tab（2026-07-22）·列表。order_status 由服务端强制为 5，前端传什么都无效。
  // 可见性走指派口径（角色数据范围 + 组下钻），归属组 = 排单落点优先·没排过回退下单组。
  getWithdrawnList: (data, options) => {
    return post("/work_order/schedule_manage/withdrawn_list", data, options)
  },
  // 已撤回工单 tab·导出（与列表同口径同 scope·走独立 sign data_scheduling_withdrawn_list）
  exportWithdrawn: (data, options) => {
    return post("/work_order/schedule_manage/withdrawn_export", data, options)
  },
  // 被驳回 tab（2026-08-31）·列表。order_status 由服务端强制为 3。
  // 与已撤回**同一套后端取数逻辑**（getRejectedList → getWithdrawnList(orderStatus=3)），
  // 可见性/归属组口径完全一致，仅 order_status 不同。
  getRejectedList: (data, options) => {
    return post("/work_order/schedule_manage/rejected_list", data, options)
  },
  // 被驳回 tab·导出（独立 sign data_scheduling_rejected_list·消费端与已撤回共用 exportSchedulingOrderTab）
  exportRejected: (data, options) => {
    return post("/work_order/schedule_manage/rejected_export", data, options)
  },
  // 工单标签下拉（挂 schedule_label_edit·2026-09-14 workOrder_v3）
  labelOptions: (data, options) => {
    return post("/work_order/schedule_manage/label_options", data, options)
  },
  // 修改工单标签（三 tab·单行/批量共用·data:{order_ids:[], config_ids:[]}·仅节点门 schedule_label_edit）
  batchUpdateLabel: (data, options) => {
    return post("/work_order/schedule_manage/batch_update_label", data, options)
  },
}
